export default __webpack_public_path__ + "static/media/river-thumb.3c8c9229.png";